import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var getGridClasses = function getGridClasses(amount) {
  switch (amount) {
    case 1:
      return 'col-12';
    case 2:
      return 'col-12 col-sm-6';
    case 3:
      return 'col-12 col-md-4';
    case 4:
      return 'col-12 col-md-6 col-lg-3';
    case 6:
      return 'col-12 col-sm-4 col-lg-2';
    case 12:
      return 'col-12 col-sm-1';
    default:
      return 'col-12';
  }
};
var TeaserContainer = function TeaserContainer(props) {
  var rowClassNames = classNames('teaser-container', 'row', 'display-flex-sm flex-wrap-sm', props.className && props.className);
  var columnClassNames;
  if (props.teaserPerRow) {
    columnClassNames = getGridClasses(props.teaserPerRow);
  } else {
    var childCount = props.children.length || 1;
    columnClassNames = getGridClasses(childCount);
  }
  var aggregatedColumnClassNames = classNames(columnClassNames, props.columnClassName && props.columnClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: rowClassNames
  }, React.Children.map(props.children, function (child) {
    return /*#__PURE__*/React.createElement("div", {
      className: aggregatedColumnClassNames
    }, child);
  }));
};
TeaserContainer.defaultValue = {
  children: []
};
TeaserContainer.propTypes = {
  teaserPerRow: PropTypes.PropTypes.oneOf([1, 2, 3, 4, 6, 12]),
  className: PropTypes.string,
  columnClassName: PropTypes.string
};
export default TeaserContainer;